import api from "../../utils/apiAuth";
import {
  setLoading,
  setError,
  setAlertMessage,
  setShowAlert,
  resetState,
} from "../slices/sifremiUnuttumSlice";

export const sifremiUnuttumRequest = (email) => async (dispatch) => {
  dispatch(setLoading(true));
  dispatch(setError(""));

  try {
    console.log("Gönderilen veri:", { email });

    const response = await api.post("/auth/request-password-reset", { email });

    console.log("API Cevabı:", response);

    if (response.status === 200) {
      dispatch(setAlertMessage("Lütfen e-posta kutunuzu kontrol ediniz."));
      dispatch(setShowAlert(true));
    } else {
      dispatch(setError("Bir hata oluştu. Lütfen tekrar deneyiniz."));
    }
  } catch (err) {
    // API'den gelen hata mesajını kullanıcıya gösterelim
    const errorMessage =
      err.response?.data?.message ||
      "E-posta adresi hatalı veya sistemde kayıtlı değil.";
    dispatch(setError(errorMessage));
  } finally {
    dispatch(setLoading(false));
  }
};

export const yeniSifreRequest = (token, newPassword) => async (dispatch) => {
  dispatch(setLoading(true));
  dispatch(setError(null));

  try {
    const response = await api.post("/auth/reset-password", {
      token: token,
      newPassword: newPassword,
    });

    if (response.status === 200) {
      dispatch(setAlertMessage("Şifreniz başarıyla güncellendi."));
      dispatch(setShowAlert(true));
    } else {
      dispatch(setError("Bir hata oluştu. Lütfen tekrar deneyiniz."));
    }
  } catch (err) {
    dispatch(setError("Bir hata oluştu. Lütfen tekrar deneyiniz."));
  } finally {
    dispatch(setLoading(false));
  }
};
